// React Dependencies
import React from 'react';

// External Dependencies
import { Skeleton } from '@material-ui/lab';
import MText from '../../../../../components/Common/MText';

const HeaderSkeleton = () => (
  <div className="d-flex flex-column" style={{ gap: '5px' }}>
    <Skeleton variant="text" animation="pulse">
      <MText size="12px" className="mb-2 " text="Loyalty Programme ID: -" />
    </Skeleton>
    <div className="d-flex align-items-center" style={{ gap: '20px', overflowX: 'auto' }}>
      {Array.from({ length: 6 }).map((key) => (
        <Skeleton key={key} variant="rect" animation="pulse" height={30} width={80} />
      ))}
    </div>
  </div>
);

export default HeaderSkeleton;
